import { inject, Injectable } from '@angular/core';
import { TerminalSalesEndpoints } from 'app/core/enums/endpoints';
import { ApiService } from 'app/services/api/api.service';
import { UtilsService } from 'app/services/utils.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class TerminalSalesService {
    private _endpoint = TerminalSalesEndpoints;
    private utils = inject(UtilsService);
    private _apiService = inject(ApiService);

    constructor() {}

    // ----------------------------------------------------------------------
    // @ Public methods
    // ----------------------------------------------------------------------
    // @ CRUD methods
    // ----------------------------------------------------------------------

    /**
     * @description
     * Get all terminal sales
     * @returns
     */
    getAll(playdateId: number): Observable<any> {
        return this._apiService.getOne(this._endpoint.getAll, playdateId);
    }

    /**
     * @description
     * Get single terminal sale
     * @returns
     */
    getOne(id: number): Observable<any> {
        return this._apiService.getOne(this._endpoint.getOne, id);
    }

    /**
     * @description
     * Create a new terminal sale
     * @returns
     */
    create(terminalSaleData: any): Observable<any> {
        return this._apiService.post(this._endpoint.create, terminalSaleData);
    }

    /**
     * @description
     * Update a terminal sale
     * @returns
     */
    update(terminalSaleData: string): Observable<any> {
        return this._apiService.update(this._endpoint.patch, terminalSaleData);
    }

    /**
     * @description
     * Delete a terminal sale
     * @returns
     */
    delete(payload: any): Observable<any> {
        return this._apiService.deleteWithParam(this._endpoint.delete, payload);
    }
}
